import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { useState } from "react";
import { useModal } from "../../hooks/useModal";
import { Modal } from "../../components/ui/modal";
import { useAxios } from "../../utils/useAxios";
import { useData } from "../../context/GetDataContext";

export const LoadStatus = ({ data }: any) => {
  const { isOpen, openModal, closeModal } = useModal();
  const { setData } = useData();
  const [age, setAge] = useState("");

  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value as string);
    openModal();
  };

  const {
    res: editRes,
    mutate: editMatate,
    isPending: editIsPending,
    error: editError,
  } = useAxios({
    url: "/api/auth/geteditdata",
    onSuccess: (data) => {
      const formData = data?.data?.data;
      setData(formData);
      handleClose();
    },
  });

  const {
    res: formRes,
    mutate: formMutate,
    isPending: formIsPending,
  } = useAxios({
    url: "/api/auth/submitdata",
    onSuccess: () => {
      console.log("1 edit get data");
      editMatate({
        editId: Number(data?.id),
        formId: "load",
        target: "edit",
      });
    },
  });

  const handleClose = () => {
    closeModal();
  };

  const handleAgree = () => {
    formMutate({
      formId: "load_status",
      formData: {
        status: deliveryStatuses.find(
          (item) => item.value.toString() === age.toString(),
        )?.label,
        load_id: data?.id,
      },
    });
  };

  const deliveryStatuses = [
    { value: 1, label: "En route" },
    { value: 2, label: "At Pickup" },
    { value: 3, label: "Loading Started" },
    { value: 4, label: "Loading Completed" },
    { value: 5, label: "In Transit" },
    { value: 6, label: "At Delivery" },
    { value: 7, label: "Unloading Started" },
    { value: 8, label: "Unloading Completed" },
    { value: 9, label: "Detention Begin" },
    { value: 10, label: "Detention Ended" },
    { value: 11, label: "Pickup Completed" },
    { value: 12, label: "Delivered" },
    { value: 13, label: "Completed" },
  ];

  return (
    <>
      <FormControl
        sx={{
          width: "150px",
          height: "20px",
        }}
        size="small"
      >
        <InputLabel
          id="demo-simple-select-label"
          sx={{
            // height: "20px",
            fontSize: "0.9rem",
            lineHeight: "1rem",
          }}
        >
          Status
        </InputLabel>
        <Select
          value={age}
          label="Age"
          onChange={handleChange}
          sx={{
            // height: "20px",
            fontSize: "0.75rem",
            lineHeight: "1rem",
          }}
        >
          {deliveryStatuses.map((item) => (
            <MenuItem value={item.value}>{item.label}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        className="max-w-[500px] m-4"
        header="Load Status Confirmation"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to assign status{" "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <ol>
              <li>
                {" "}
                Status:
                {
                  deliveryStatuses.find(
                    (item) => item.value.toString() === age.toString(),
                  )?.label
                }{" "}
              </li>
              <li>Load: {data?.id}</li>
            </ol>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            disabled={editIsPending || formIsPending}
          >
            Disagree
          </Button>
          <Button
            onClick={handleAgree}
            autoFocus
            disabled={editIsPending || formIsPending}
            loading={editIsPending || formIsPending}
          >
            Agree
          </Button>
        </DialogActions>
      </Modal>
    </>
  );
};
